import { render } from "./CustomerModal.vue?vue&type=template&id=cb50b50e&ts=true"
import script from "./CustomerModal.vue?vue&type=script&lang=ts"
export * from "./CustomerModal.vue?vue&type=script&lang=ts"

import "./CustomerModal.vue?vue&type=style&index=0&id=cb50b50e&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__